module.exports = __webpack_public_path__ + "img/white.3d476b5c.png";